import { COMMON_ICONS } from '../../../../../common/components/svg/icons/icons';
import { STANDARD_ICONS } from './standard-icons';

export const Icon = ({ name, ...props }) => {
  const ICONS = {
    ...COMMON_ICONS(props),
    ...STANDARD_ICONS(props)
  };
  return ICONS[name] || '';
};
